export enum DisplayLogicConditionError {
	NoSourceSelected,
	HasOtherSourceAndSingleLinkSelection,
	HasOtherSourceAndHierarchySelection,
	HasHierarchySourceAndAttributeSelection,
}
